export default __webpack_public_path__ + "static/media/breakline.73658c2b.svg";